import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ee95efaa&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee95efaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee95efaa')) {
      api.createRecord('ee95efaa', component.options)
    } else {
      api.reload('ee95efaa', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ee95efaa&scoped=true&", function () {
      api.rerender('ee95efaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QEDlzU2gq8Qd/JS/comp/Accordion.vue"
export default component.exports